import { ellipsisIcon } from '@treasury/presentation/assets/icons';
import { ContextMenuItem } from '@vaadin/context-menu';
import '@vaadin/grid/vaadin-grid-column.js';
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../tm-base.component';
import './tm-context-menu';

export const tagName = 'tm-actions-column';
@customElement(tagName)
export class TmActionsColumn extends TmBaseComponent {
    @property({ attribute: false })
    public items: Array<ContextMenuItem> = [];

    protected render() {
        return html`${this.renderActions()}`;
    }

    private renderActions() {
        if (this.items.length === 0) {
            return nothing;
        }
        return html`<tm-context-menu
            .items=${this.items}
            .openOn=${'click'}
            @item-selected=${(e: CustomEvent) => {
                this.dispatchEvent(new CustomEvent('action-selected', { detail: e.detail }));
            }}
        >
            <div class="flex items-center cursor-pointer select-none">
                <tm-button importance="tertiary">
                    <tm-icon .icon=${ellipsisIcon} color="var(--content-default)"></tm-icon>
                </tm-button>
            </div>
        </tm-context-menu>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                    width: 20px;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmActionsColumn;
    }
}
